import { useAuth0 } from "@auth0/auth0-react";
import { WebAppConfig } from "@/infrastructure/services/config/AppConfig";
import { sessionRepository } from "@/infrastructure/repositories/session/Session.repository";

export function useAuth() {
  const auth0 = useAuth0();
  const config = WebAppConfig.getInstance();

  const logout = () => {
    sessionRepository.clear();

    if (!config.isAuthConfigured()) {
      return;
    }

    void auth0.logout({
      logoutParams: {
        returnTo: `${globalThis.location.origin}/login`,
      },
    });
  };

  const login = () => {
    if (!config.isAuthConfigured()) {
      return;
    }

    void auth0.loginWithRedirect({
      appState: { returnTo: "/dashboard" },
    });
  };

  return {
    ...auth0,
    login,
    logout,
    isAuthConfigured: config.isAuthConfigured(),
  };
}
